import styled from 'styled-components';

export const StyledTimeLeft = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 30px;

  .clock {
    margin-left: 10px;
  }
`;
